var docElement = require('./docElement.js');
/**
 * A convenience helper to check if the document we are running in is an SVG document
 *
 * @access private
 * @returns {boolean}
 */


var isSVG = docElement.nodeName.toLowerCase() === 'svg';
module.exports = isSVG;